import { useRef } from 'react';
import { Volume2, VolumeX } from 'lucide-react';
import { RangeSlider } from '../RangeSlider/RangeSlider';
import './VolumeSlider.css';

type Props = {
    volume: number;
    onVolumeChange: (volume: number) => void;
};

export function VolumeSlider({ volume, onVolumeChange }: Props) {
    const isMuted = volume === 0;
    // Remembers the level to restore to on unmute - not state, since it
    // should track the last nonzero volume without itself triggering a
    // re-render.
    const lastVolumeRef = useRef(volume || 0.8);
    if (volume > 0) lastVolumeRef.current = volume;

    const toggleMute = () => {
        onVolumeChange(isMuted ? lastVolumeRef.current : 0);
    };

    return (
        <div className="volumeControl">
            <button
                className="volumeIconButton"
                onClick={toggleMute}
                aria-label={isMuted ? 'Unmute' : 'Mute'}
            >
                {isMuted ? <VolumeX size={16} strokeWidth={2.75} /> : <Volume2 size={16} strokeWidth={2.75} />}
            </button>
            <RangeSlider max={1} value={volume} onChange={onVolumeChange} ariaLabel="Volume" />
        </div>
    );
}
